export default "__VITE_ASSET__2f5fe485__"